import React from 'react'
import ReactDOM from 'react-dom'
import App from './App.js'
import './global.css'
import { BrowserRouter as Router } from 'react-router-dom'
import { ResultContextProvider } from './contexts/ResultContextProvider.js'

ReactDOM.render(
  <ResultContextProvider>
    <Router>
      <App />
    </Router>
  </ResultContextProvider>,
 document.getElementById('root'))